import convert from 'color-convert';

export const DEFAULT_RGB = { r: 127, g: 127, b: 127 };

export const isValidRGB = value => {
  return (
    typeof value === 'object' && 'r' in value && 'g' in value && 'b' in value
  );
};

// ref: http://www.brucelindbloom.com/index.html?Eqn_xyY_to_XYZ.html
const xyyToXyz = (x, y, Y = 1) => {
  const X = (x * Y) / y;
  const Z = ((1.0 - x - y) * Y) / y;

  return { X, Y, Z };
};

const xyzToXyy = (X, Y, Z) => {
  const x = X / (X + Y + Z);
  const y = Y / (X + Y + Z);

  return { x, y, Y };
};

export const rgbToXy = (r, g, b) => {
  const [X, Y, Z] = convert.rgb.xyz(r, g, b);
  const { x, y } = xyzToXyy(X, Y, Z);

  return { x, y };
};

export const xyToRgb = (x, y) => {
  const { X, Y, Z } = xyyToXyz(x, y);
  const [r, g, b] = convert.xyz.rgb([X * 100.0, Y * 100.0, Z * 100.0]);

  return { r, g, b };
};

export const parseXyToRgbValue = value => {
  try {
    if (!value || typeof value !== 'string') return DEFAULT_RGB;

    const { x = 0, y = 0 } = JSON.parse(value);
    return xyToRgb(x, y);
  } catch (error) {
    console.error(
      `Could not convert ${value} to RGB. A default value will be applied. Error: ${error}`,
    );
    return DEFAULT_RGB;
  }
};
